import React from "react";
import Layout from "../components/Layout";
import GameCard from "../components/GameCard";
import { useLanguage } from "../i18n/LanguageContext";
import "../styles/Home.css";

function Home() {
  const { t } = useLanguage();

  return (
    <Layout>
      <section className="panel hero">
        <img src="/images/logo/logo.png" alt="Frost Wyrm Studios" className="hero-logo" />
        <div className="hero-text">
          <h1>{t.home.welcome}</h1>
          {t.home.intro.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </section>

      <section aria-labelledby="coming-soon-title">
        <h2 id="coming-soon-title" className="section-title">{t.home.comingSoon}</h2>
        <GameCard
          featured
          title="Little Mages 3D"
          url="https://store.steampowered.com/app/5255270/Little_Mages_3D/"
          image="/images/games/little-mages-3d.jpg"
          backdrop="/images/games/little-mages-3d-backdrop.jpg"
          badge={t.games.littleMages3d.badge}
          description={t.games.littleMages3d.description}
          buttonLabel={t.games.littleMages3d.button}
        />
      </section>

      <section aria-labelledby="out-now-title">
        <h2 id="out-now-title" className="section-title">{t.home.outNow}</h2>
        <GameCard
          title="Little Mages"
          url="https://store.steampowered.com/app/2560320/Little_Mages/"
          image="/images/games/460x215.png"
          description={t.games.littleMages.description}
          buttonLabel={t.games.littleMages.button}
        />
      </section>
    </Layout>
  );
}

export default Home;
